import { EQCompany, initializeCompany } from "./EQCompany";
import { EQDepartment, initialDepartmentList } from "./EQDepartment";

export interface EQUser {
  // 사용자
  // 상위 항목 : EQDepartment
  // DB Field
  uid: number; // 고유값
  guid: string; // GUID
  userLevel: number; // 사용자 등급  0 - 없음(None), 1 - 최고 어드민(SuperAdmin),  2 - 협회 마스터(Master), 3 - 업체 관리자(Manager), 4 - 업체 담당자(Officer), 5 - 게시판관리자(BoardManager)
  companyUID: number; // 사업체 UID
  departmentUID: number; // 부서 UID
  name: string; // 이름
  loginID: string; // 로그인 ID
  loginPW: string; // 로그인 비밀번호
  email: string; // 이메일
  extra: string; // 기타

  address: string; // 주소
  phone: string; // 전화번호

  expireDate: Date | string; // 만료일

  entryDate: Date | string; // 등록일
  modifyDate: Date | string; // 수정일
  registerDate: Date | string; // 입사일

  isDeleted: boolean; // 삭제여부

  // Non DB
  token: string; // 토큰
  l1: string; // 리디렉션 L1
  l2: string; // 리디렉션 L2
  company: EQCompany;
  department: EQDepartment;
}

export const initializeUser = (level = 4): EQUser => {
  return {
    uid: 0, // 고유값
    guid: "00000000-0000-0000-0000-000000000000", // GUID
    userLevel: level, // 사용자 등급  0 - 없음(None), 1 - 최고 어드민(SuperAdmin),  2 - 협회 마스터(Master), 3 - 업체 관리자(Manager), 4 - 업체 담당자(Officer), 5 - 게시판관리자(BoardManager)
    companyUID: 0, // 사업체 UID
    departmentUID: 0, // 부서 UID
    name: "", // 이름
    loginID: "", // 로그인 ID
    loginPW: "", // 로그인 비밀번호
    email: "", // 이메일
    extra: "", // 기타

    address: "", // 주소
    phone: "", // 전화번호

    expireDate: new Date(new Date().getFullYear() + 2, 11, 31), // 만료일

    entryDate: new Date(), // 등록일
    modifyDate: new Date(), // 수정일
    registerDate: new Date(), // 입사일

    isDeleted: false, // 삭제여부

    // Non DB
    token: "", // 토큰
    l1: "",
    l2: "",
    company: initializeCompany(),
    department: { ...initialDepartmentList },
  };
};

export interface userListParams {
  token: string;
  page: number;
  rows?: number;
  searchWord: string;
  type: number;
}

export const initializeUserListParams = (token = "", page = 1, rows = 20, searchWord = "", type = 4): userListParams => {
  return {
    token: token,
    page: page,
    rows: rows,
    searchWord: searchWord,
    type: type,
  };
};
